import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ekeg5d6pr: FaireProductEntity = {
  token: "p_3ekeg5d6pr",
  type: "product",
  name: "Baseball Sister I'm Just Here For The Snacks Shirt",
  brandToken: "b_qqvkwetda4",
  brandName: "Madi Moosh",
  imageUrl:
    "https://cdn.faire.com/fastly/4b72c5162bae3744865415d04ff73fc591fd39bbcee56bdb82cc4cf495ad6dd8.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4ac510abe329e338baafb00ea9d5e4872d6b698c1be5d424e9195d54cb8ef9e9.png",
    "https://cdn.faire.com/fastly/ef1d246bed6a2418faeb90f144dbddaa6b771196f75988b9020cd36e86353714.png",
    "https://cdn.faire.com/fastly/aabe1181e49c1357b6536fab170d3b9d2f4aec86d79eb9250970514babb256ef.png",
  ],
  priceDollars: 12.98,
  description:
    "\nWelcome to Madi Moosh \n\nWe have sold over 150000 thousand shirts and received over 50 thousand feedbacks on our Etsy stores.\n\n\nOur goal as always is to supply high quality kids and adult clothing for all occasions.\n\nAll Tees are 100% cotton and printed on Bella Canvas brand shirts. We may substitute Bella Canvas for a comparable brand if unavailable at the time you place your order. If you have any questions regarding the brand of shirt you will receive please let us know.\n\nPlease see the photos for size charts and size information\n\nAbout our process:\n- All orders are made to order and printed using Direct To Garment printing technology.\nUnlike other garment decorating processes, this process allows for a super soft print that will last for years.",
  tags: [],
  msrpDollars: 25.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:01.411Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
